import React from 'react';
import PropTypes from 'prop-types';

import {
  getIdentityFullName,
  getIdentityAccounts,
} from '../../../../../util/identity';
import {
  getAccountLastDigits,
  getAccountName,
} from '../../../../../util/account';
import IdentityAvatar from '../../../../../components/global/identity/IdentityAvatar';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
  context: PropTypes.string,
};

const IdentityOptionLabel = ({ identity, context }) => {
  if (context === 'value') {
    return getIdentityFullName(identity, identity.account);
  }

  const accounts = getIdentityAccounts(identity);

  return (
    <span className="tag-option" key={identity.id}>
      <div className="d-flex">
        <IdentityAvatar
          key={identity.id}
          identity={identity}
          title={identity.name}
          className="mr-1"
        />
        <div>
          <span className="text-dark d-block">
            {getIdentityFullName(identity, identity.account)}
          </span>
          {accounts.map(account => {
            if (!account) {
              return null;
            }

            const number = getAccountLastDigits(account);

            return (
              <span className="d-block text-faded" key={account.id}>
                {getAccountName(account)} {number && `(${number})`}
              </span>
            );
          })}
        </div>
      </div>
    </span>
  );
};

IdentityOptionLabel.propTypes = propTypes;

export default IdentityOptionLabel;
